__turbopack_context__.v({
  "container": "SoldAndShippedByTag-module-scss-module__mKDvyG__container",
  "icon": "SoldAndShippedByTag-module-scss-module__mKDvyG__icon",
  "simpleButton": "SoldAndShippedByTag-module-scss-module__mKDvyG__simpleButton",
});
